import { Injectable } from '@angular/core';
import { CentrexExtensionsService } from './centrex-extensions.service';
import { CentrexUsersService } from './centrex-users-service';
import { CentrexServicesService } from './centrex-services.service';
import { CentrexSdasService } from './centrex-sdas.service';
import { forkJoin, map } from 'rxjs';
import { CentrexDevicesService } from './centrex-device.service';
import { CentrexRegistrationState } from '../models/centrex-device.model';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  constructor(
    private usersService: CentrexUsersService,
    private extensionsService: CentrexExtensionsService,
    private sdasService: CentrexSdasService,
    private servicesService: CentrexServicesService,
    private devicesService: CentrexDevicesService,
  ) {}

  getStats(orgId: string, platform: string) {

    console.log('[DashboardService] getStats', {
  orgId,
  platform,
});

    const extensionsRequest =
      platform === 'Centrex Enreach'
        ? this.extensionsService.getExtensionGroups(orgId, platform)
        : this.extensionsService.getExtensions(orgId, platform);

    return forkJoin({
      users: this.usersService
        .getAllCentrexUsers(orgId, platform)
        .pipe(map((v) => v ?? [])),

      extensions: extensionsRequest.pipe(map((v) => v ?? [])),

      sdas: this.sdasService.getSdas(orgId, platform).pipe(map((v) => v ?? [])),

      devices: this.devicesService
        .getDevices(orgId, platform)
        .pipe(map((v) => v ?? [])),
    }).pipe(
      map(({ users, extensions, sdas, devices }) => {
        const groups =
          platform === 'Centrex NG'
            ? extensions.filter((e) => e?.type === 'group')
            : extensions;

        return {
          // USERS
          usersActive: users.filter((u) => u?.enabled === true).length,
          usersBlocked: users.filter((u) => u?.enabled === false).length,

          // GROUPES
          groupsActive: groups.filter((e) => e?.enabled === true).length,
          groupsInactive: groups.filter((e) => e?.enabled === false).length,

          // SDA
          sdaAffected: sdas.filter((s) => !!s?.target).length,
          sdaUnaffected: sdas.filter((s) => !s?.target).length,

          // DEVICES
          devicesOn: devices.filter((d) => d?.state === 'registered').length,
          devicesHs: devices.filter((d) => d?.state === 'unregistered').length,
          devicesDisconnected: devices.filter((d) => d?.state === 'undefined')
            .length,
        };
      }),
    );
  }
}
